const emptyResults = {
    products: [],
    suppliers: [],
}

const baseState = {
    autoCompleteResults: emptyResults,
    pageResults: emptyResults,
    searchValue: '',
    pageSearchLoading: true,
    query: '',
}

export default function reducer(state = baseState, action) {
    switch (action.type) {
        case 'INIT_SEARCH_VALUE':
        case 'CHANGE_SEARCH_VALUE':
            return {
                ...state,
                searchValue: action.payload,
            }
        case 'AUTOCOMPLETE_SEARCH':
            return {
                ...state,
                query: action.payload,
            }
        case 'PRODUCT_AUTOCOMPLETE_SEARCH_SUCCESS':
            return {
                ...state,
                autoCompleteResults: {
                    ...state.autoCompleteResults,
                    products: action.payload.products,
                },
            }
        case 'SUPPLIER_AUTOCOMPLETE_SEARCH_SUCCESS':
            return {
                ...state,
                autoCompleteResults: {
                    ...state.autoCompleteResults,
                    suppliers: action.payload.suppliers,
                },
            }
        case 'PAGE_SEARCH':
            return {
                ...state,
                query: action.payload,
                pageSearchLoading: true,
            }
        case 'PRODUCT_PAGE_SEARCH_SUCCESS':
            return {
                ...state,
                pageResults: {
                    ...state.pageResults,
                    products: action.payload.products,
                },
                pageSearchLoading: false,
            }
        case 'SUPPLIER_PAGE_SEARCH_SUCCESS':
            return {
                ...state,
                pageResults: {
                    ...state.pageResults,
                    suppliers: action.payload.suppliers,
                },
                pageSearchLoading: false,
            }
        case 'USER_LOGOUT':
        case 'SET_REGION':
            return { ...baseState }
        default:
            return state
    }
}
